import { gql } from "@apollo/client";

export const GET_PUBLIC_EVENTS = gql`
  query GetPublicEvents {
    getPublicEvents {
      id
      title
      description
      date
      liveDate
      imageUrl
      recurrence
      recurrenceDay
    }
  }
`;

export const GET_PUBLIC_EVENT = gql`
  query GetPublicEvent($id: ID!) {
    getPublicEvent(id: $id) {
      id
      title
      description
      date
      liveDate
      imageUrl
      recurrence
      recurrenceDay
    }
  }
`;
